namespace TabAurous.Retail {
    export namespace OpenConsignmentOutDetailedService {
        export const baseUrl = 'Retail/OpenConsignmentOutDetailed';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<Reports.StockBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/OpenConsignmentOutDetailed/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OpenConsignmentOutDetailedService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
